import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=326febac&"
import script from "./Pricing.vue?vue&type=script&lang=ts&"
export * from "./Pricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326febac')) {
      api.createRecord('326febac', component.options)
    } else {
      api.reload('326febac', component.options)
    }
    module.hot.accept("./Pricing.vue?vue&type=template&id=326febac&", function () {
      api.rerender('326febac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/Pricing.vue"
export default component.exports